import styled from 'styled-components';

export const FullWidthImage = styled.div`
  height: 65vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 2rem;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    height: 30vh;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const ArticleImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.7));
  pointer-events: none;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

export const ImageTitle = styled.h1`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  width: 90%;
  max-width: 1100px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

export const ArticleContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 1.5rem 1rem;
`;

export const ArticleSectionStyle = styled.section`
  margin-bottom: 2.5rem;

  &:first-of-type {
    margin-top: 1rem;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-align: right;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ArticleText = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  text-align: right;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const List = styled.ul`
  padding-right: 1.5rem;
  margin-bottom: 1.5rem;
  direction: rtl;
`;

export const ListItem = styled.li`
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const BackButtonWrapper = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 10;

  button {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 0.8rem 1.2rem;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    box-shadow: ${({ theme }) => theme.shadows.medium};
    font-size: 1.1rem;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.white};
      transform: translateX(5px);
    }
  }
`;

export const ImageTextSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  margin-bottom: 2.5rem;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SectionImage = styled.img`
  width: 45%;
  height: auto;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  object-fit: cover;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TextContent = styled.div`
  flex: 1;
  text-align: right;
`;

export const StyledBackButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: transform 0.2s;
  flex-direction: row-reverse;

  &:hover {
    transform: translateX(-5px);
  }
`;
